import { useEffect, useState } from "react";

export default function useImportScript(scriptURL, callback) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!scriptURL) return;

    const scriptID = "fnrscript_" + scriptURL.replace(/[^a-zA-Z0-9]/g, "");
    const scriptEl = document.querySelector(`script#${scriptID}`);

    if (scriptEl) {
      setIsLoaded(true);
      if (callback) callback(true);
      return;
    }

    setIsLoaded(false);

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = scriptURL;
    script.id = scriptID;
    script.onload = () => {
      setIsLoaded(true);
      if (callback) callback(true);
    };
    document.body.appendChild(script);
  }, [scriptURL, callback]);

  return isLoaded;
}
